//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { IMAGE_TAGGING_PERMISSION } from '@content-drawer/contentDrawerConstants';
import { getSessionInfo } from '@redux/selectors/getSessionInfo';

export const getHasUniversalImageActionsTaggingPermission = createSelector(
  getSessionInfo,
  (sessionInfo) => sessionInfo.permissions[IMAGE_TAGGING_PERMISSION],
);
